/* global axios */
import ApiClient from './ApiClient';

// Aba Disparos da caixa (so user id 1; guard no backend InboxPolicy).
// Campanhas de disparo de template: criar, subir itens, disparar/continuar,
// pausar e relatorio paginado.
class InboxDispatchesAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  listCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/dispatch_campaigns`);
  }

  createCampaign(inboxId, campaign) {
    return axios.post(`${this.url}/${inboxId}/create_dispatch_campaign`, {
      campaign,
    });
  }

  addItems(inboxId, campaignId, items) {
    return axios.post(`${this.url}/${inboxId}/add_dispatch_items`, {
      campaign_id: campaignId,
      items,
    });
  }

  startDispatch(inboxId, campaignId) {
    return axios.post(`${this.url}/${inboxId}/start_dispatch`, {
      campaign_id: campaignId,
    });
  }

  pauseDispatch(inboxId, campaignId) {
    return axios.post(`${this.url}/${inboxId}/pause_dispatch`, {
      campaign_id: campaignId,
    });
  }

  listItems(inboxId, campaignId, page, result) {
    return axios.get(`${this.url}/${inboxId}/dispatch_campaign_items`, {
      params: { campaign_id: campaignId, page, ...(result ? { result } : {}) },
    });
  }

  // Historico central (menu Meta): campanhas de todas as caixas, 20/pagina.
  history(page, inboxId) {
    return axios.get(`${this.baseUrl()}/meta_central/dispatch_history`, {
      params: { page, ...(inboxId ? { inbox_id: inboxId } : {}) },
    });
  }
}

export default new InboxDispatchesAPI();
